"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _FourMediaLayout = require("./FourMediaLayout");
Object.keys(_FourMediaLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _FourMediaLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _FourMediaLayout[key];
        }
    });
});
